module.exports = __webpack_public_path__ + "media/images/desktop_kv-a11a62fe1ba1f46a46bedaab5288a9cd.jpg";